import React, { useState, useEffect } from 'react'

const TypingIndicator = () => {
    const [typingIndicatorDotsCount, setTypingIndicatorDotsCount] = useState(1)

    useEffect(() => {
        let interval = setInterval(() => {
            setTypingIndicatorDotsCount(prev => prev == 6 ? 0 : prev + 1)
        }, 750);

        return () => clearInterval(interval)
    }, [])

    return (
        <div className='typing-indicator-container'>
            {`Typing${".".repeat(typingIndicatorDotsCount)}`}
        </div>
    )
}

export default TypingIndicator
